import React from "react"
import ReactDOM from "react-dom/client"
import MentorSignupForm from "./MentorSignupForm"

const root = ReactDOM.createRoot(document.getElementById("root"))
root.render(<MentorSignupForm />)
